const FAQ_ITEMS = [
  {
    id: 1,
    q: '吃瓜爆料网是做什么的？',
    a: '吃瓜爆料网是一个专业的吃瓜爆料网站聚合导航平台，收录了全网200+各类吃瓜爆料网站，涵盖娱乐圈、网红圈、综艺节目、体育电竞等领域的吃瓜平台入口，帮助用户一站式找到最新、最热的吃瓜爆料网站。',
  },
  {
    id: 2,
    q: '网站收录的吃瓜爆料平台靠谱吗？',
    a: '我们采用人工审核机制，所有收录的吃瓜爆料网站都经过团队严格筛选和定期复查。我们会持续跟踪各平台的运营状态、内容质量和更新频率，确保推荐的每一个平台都值得信赖。',
  },
  {
    id: 3,
    q: '排名榜单多久更新一次？',
    a: '榜单会根据各吃瓜爆料网站的活跃度、内容更新频率和用户反馈每日进行刷新调整。你可以随时回来查看最新的吃瓜爆料网站排名，不错过任何热门平台。',
  },
  {
    id: 4,
    q: '移动端可以使用吗？',
    a: '当然可以！吃瓜爆料网全面适配移动端设备，在手机和平板上都能流畅使用。我们提供了移动端专属的吃瓜入口，方便你随时随地浏览各种吃瓜爆料网站。',
  },
  {
    id: 5,
    q: '如何推荐新的吃瓜爆料网站？',
    a: '如果你发现了新的优质吃瓜爆料网站，欢迎通过页面底部的联系方式向我们推荐。我们的审核团队会尽快评估，符合标准的平台会被及时收录到导航中。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            答疑解惑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
        </div>

        <div className="max-w-3xl mx-auto divide-y divide-background-200/70">
          {FAQ_ITEMS.map((item) => (
            <div key={item.id} className="py-5 md:py-6">
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                {item.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}